import { useAppLogo } from "helpers/useAppSetting";
import React from 'react';
import PropTypes from 'prop-types';
import { CHECK_CLS, VALUE_CLS } from "../../pifStyles";

const CHECK_LABEL_CLS = "tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-select-none";

const BDSGeneralInformation = ({ data }) => {
  const logo = useAppLogo();
  const { project, building, adaptation, area } = data;

  return (
    <div className="tw-flex tw-gap-x-3 tw-text-sm">
      <div>
        <img
          src={logo}
          alt="Logo Pebsteel"
          width="160"
          height="60"
          className="tw-object-contain tw-rounded-sm"
          style={{maxWidth: '100%'}}
        />
      </div>
      <div className="tw-flex-1 tw-grid tw-grid-cols-10 tw-gap-x-3">
        <div className="tw-col-span-3">
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>Quote No:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{project?.q_number}</span></div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>P/Job No:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{building?.j_number}</span></div>
          </div>
        </div>
        <div className="tw-col-span-2">
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>CO#:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.co || '00'}</span></div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>REV#:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.rev}</span></div>
          </div>
        </div>
        <div className="tw-col-span-2">
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>Date:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.entry_date}</span></div>
          </div>
          <div className="tw-flex tw-gap-x-2 tw-mb-2">
            <div>Date:</div>
            <div className="tw-flex-1"><span className={VALUE_CLS}>{adaptation?.entry_date}</span></div>
          </div>
        </div>
        <div className="tw-col-span-3">
          <div className="tw-flex tw-gap-x-3">
            <div>
              <label className={CHECK_LABEL_CLS}>
                <input type="checkbox" className={CHECK_CLS} />
                <span>For Order Entry</span>
              </label>
            </div>
            <div className="tw-flex-1">
              <label className={CHECK_LABEL_CLS}>
                <input type="checkbox" className={CHECK_CLS} checked readOnly />
                <span>For Quotation</span>
              </label>
            </div>
          </div>
          <div className="tw-flex tw-gap-x-3">
            <div>
              <div>Bldg No : <span className={VALUE_CLS}>{building?.name}</span></div>
            </div>
            <div className="tw-flex-1">
              <div>Area No: <span className={VALUE_CLS}>{area.id}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

BDSGeneralInformation.propTypes = {
  data: PropTypes.object.isRequired
}

export default BDSGeneralInformation;
